import React, { useCallback } from 'react';

import HelpButton from './HelpButton';
import PanelTitle from './PanelTitle';
import CloseButton from './CloseButton';
import BackButton from './BackButton';
import PanelLeftIcon from './PanelLeftIcon';
import { WARNING_PANEL_LABELS } from '../constants/StudioModal.constants';

type Props = {
  modalName?: string;
  showBackBtn?: boolean;
  hideHelpBtn?: boolean;
  closeIconTestId?: string;
  showWarning?: boolean;
  showError?: boolean;
  hideCloseButton?: boolean;
  closeModal?: () => void;
  handleGoBack?: () => void;
  helpContent: React.ReactNode | null;
};

function TitleBar({
  modalName,
  showError,
  showBackBtn = false,
  hideHelpBtn,
  showWarning,
  closeIconTestId,
  hideCloseButton,
  closeModal,
  handleGoBack,
  helpContent,
}: Props) {
  const handleGoBackBtn = useCallback(() => {
    if (handleGoBack) {
      handleGoBack();
    } else {
      return;
    }
  }, [handleGoBack]);

  return (
    <div
      data-testid="title-bar"
      className="tw:bg-primary-100 tw:flex tw:h-[56px] tw:items-center tw:justify-between tw:relative"
    >
      {(showBackBtn || showWarning || showError) && (
        <div className="h-inherit tw:flex">
          {showBackBtn && (
            <BackButton
              showBackBtn={showBackBtn}
              data-testid="handle-go-back"
              onClick={handleGoBackBtn}
            />
          )}
          <PanelLeftIcon show={showError || false} variant="error" />
          <PanelLeftIcon show={showWarning || false} variant="warning" />
        </div>
      )}
      <PanelTitle modalName={showWarning ? WARNING_PANEL_LABELS.attention : modalName || ''} />
      <div className="h-inherit tw:flex tw:items-center">
        {!hideHelpBtn && helpContent !== null && <HelpButton helpContent={helpContent} />}
        <CloseButton
          data-testid={closeIconTestId || 'close-modal-button'}
          hideCloseButton={hideCloseButton || false}
          onClick={closeModal}
        />
      </div>
    </div>
  );
}

export default TitleBar;
